"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelixTag = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@twurple/common");
/**
 * A stream tag.
 */
let HelixTag = class HelixTag extends common_1.DataObject {
    /**
     * The ID of the tag.
     */
    get id() {
        return this[common_1.rawDataSymbol].tag_id;
    }
    /**
     * Whether the tag is automatically assigned by Twitch.
     */
    get isAuto() {
        return this[common_1.rawDataSymbol].is_auto;
    }
    /**
     * Gets the name of the tag in the specified language.
     */
    getName(language) {
        return this[common_1.rawDataSymbol].localization_names[language];
    }
    /**
     * Gets the description of the tag in the specified language.
     */
    getDescription(language) {
        return this[common_1.rawDataSymbol].localization_descriptions[language];
    }
};
HelixTag = tslib_1.__decorate([
    common_1.rtfm('api', 'HelixTag', 'id')
], HelixTag);
exports.HelixTag = HelixTag;
